import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import App from './App.jsx';
import CareersPage from './Careers.jsx';
// import AboutUs from './AboutUs.jsx';

// Preloader Component
const Preloader = ({ onComplete }) => {
  const [showLoader, setShowLoader] = useState(true);

  useEffect(() => {
    const sequence = [
      setTimeout(() => {
        setShowLoader(false);
        onComplete();
      }, 1800),
    ];
    return () => sequence.forEach((timer) => clearTimeout(timer));
  }, [onComplete]);

  return (
    <AnimatePresence>
      {showLoader && (
        <motion.img
          src="./images/output_image3.png"
          alt="Flashing"
          style={{
            position: 'fixed',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: '325px',
            height: 'auto',
            backgroundColor: 'black',
            zIndex: 9999,
          }}
          initial={{ opacity: 0 }}
          animate={{
            opacity: [0, 1, 0], 
          }}
          transition={{
            opacity: {
              duration: 2,
              repeat: Infinity, 
              repeatType: 'mirror', 
              ease: 'easeInOut', 
            },
          }}
        />
      )}
    </AnimatePresence>
  );
};


// Root Component (handles loading state and routes)
const RootComponent = () => {
  const [isLoading, setIsLoading] = useState(true);

  const handlePreloaderComplete = () => {
    setIsLoading(false);
  };

  return (
    <div style={{ backgroundColor: 'black', minHeight: '100vh' }}>
      <Router>
        {isLoading && <Preloader onComplete={handlePreloaderComplete} />}
        {/* overflow: isLoading ? 'hidden' : '' */}
        <div style={{opacity: isLoading ? 0 : 1, overflow: isLoading ? 'hidden' : '', transition: 'opacity 2s ease-in', backgroundColor: 'black' }}>
          
          <Routes>
            <Route path="/" element={<App />} />
            <Route path="/careers" element={<CareersPage />} />
            {/* <Route path="/aboutus" element={<AboutUs />} /> */}
            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
        </div>
      </Router>
    </div>
  );
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<RootComponent />);




// const Preloader = ({ onComplete }) => {
//   const [moveToTop, setMoveToTop] = useState(false);
//   const [popAtTop, setPopAtTop] = useState(false);
//   const [hideLoader, setHideLoader] = useState(false);

//   useEffect(() => {
//     const moveTimer = setTimeout(() => setMoveToTop(true), 800);
//     const popTimer = setTimeout(() => setPopAtTop(true), 1200);
//     const endTimer = setTimeout(() => {
//       setHideLoader(true);
//       onComplete();
//     }, 2000);

//     return () => {
//       clearTimeout(moveTimer);
//       clearTimeout(popTimer);
//       clearTimeout(endTimer);
//     };
//   }, [onComplete]);

//   return (
//     <AnimatePresence>
//       {!hideLoader && (
//         <motion.div
//           style={{
//             position: 'fixed',
//             top: 0,
//             left: 0,
//             width: '100vw',
//             height: '100vh',
//             display: 'flex',
//             justifyContent: 'center',
//             alignItems: moveToTop ? 'flex-start' : 'center',
//             zIndex: 9999,
//             backgroundColor: 'black',
//             pointerEvents: 'none',
//             paddingTop: moveToTop ? '3vh' : '0',
//           }}
//           initial={{ opacity: 0 }}
//           animate={{ opacity: 1 }}
//           exit={{ opacity: 0 }}
//           transition={{ duration: 0.6 }}
//         >
//           <motion.img
//             src="./images/output_image3.png"
//             alt="Logo"
//             style={{
//               width: '325px',
//               height: 'auto',
//             }}
//             initial={{ scale: 1 }}
//             animate={{ scale: popAtTop ? [1, 1.4, 1] : 1 }}
//             transition={{ scale: { duration: 0.3 } }}
//           />
//         </motion.div>
//       )}
//     </AnimatePresence>
//   );
// };